import { useRef, useState, type ChangeEvent } from "react";

// Anti-bot honeypot for public forms. Spread `inputProps` onto an <input>
// inside the form (it's visually hidden + out of the tab/a11y order, so real
// users never fill it), and send `website` + `elapsedMs()` to the mutation.
// The server rejects a filled honeypot or an implausibly fast submission
// (see the Honeypotable concern). Layered on top of rate limiting.
export function useHoneypot() {
  const mountedAt = useRef(Date.now());
  const [website, setWebsite] = useState("");

  // The input is named `fax_number` (not `website`/`url`) on purpose: password
  // managers and browser autofill fill recognised hidden fields by NAME
  // regardless of CSS visibility, so an autofill-prone name would trip the trap
  // for real users. The value is still sent to the server as the `website`
  // GraphQL argument — autofill never sees the GraphQL layer.
  const inputProps = {
    type: "text",
    name: "fax_number",
    tabIndex: -1,
    autoComplete: "off",
    "aria-hidden": true,
    value: website,
    onChange: (e: ChangeEvent<HTMLInputElement>) => setWebsite(e.target.value),
    style: { position: "absolute" as const, left: "-9999px", width: "1px", height: "1px", opacity: 0 },
  };

  return {
    website,
    elapsedMs: () => Date.now() - mountedAt.current,
    inputProps,
  };
}
